import {addSlug} from 'shared';
import {z} from 'zod';

export const categoryPresetSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    categoryCount: z.number().positive(),
    modified: z.coerce.date(),
  })
  .transform(addSlug);

export const categoryPresetPayloadSchema = z.object({
  name: z.string().trim().min(2).max(30),
  categories: z.string().array().min(1).max(30),
});
